import {AfterViewInit, Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {SwiperComponent, SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-slider-teaser',
  templateUrl: './slider-teaser.component.html'
})
export class SliderTeaserComponent implements OnInit, AfterViewInit {

  @Input() data: {title: string, items: []};

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    init: true,
    slidesPerView: 1,
    effect: 'fade'
  };

  slides: boolean;

  isNan = isNaN;

  @ViewChild('swiper', { static: true }) swiper: SwiperComponent;

  constructor() { }

  ngOnInit() {
    this.slides = this.data.items.length > 1;
  }

  ngAfterViewInit() {
    const slider = document.getElementsByClassName('slider-teaser');
    const currentSlide = this.swiper.directiveRef.swiper().el.parentElement.parentElement.getElementsByClassName('current-slide')[0];
    for (let i = 0; i < slider.length; i++) {
      const swiperSlides = slider[i].getElementsByClassName('swiper-slide');
      let totalNumber = swiperSlides.length;
      const pagination = slider[i].getElementsByClassName('overview__teaser-slider-pagination');
      let setNumber;
      if (totalNumber < 10) {
        setNumber = '0' + totalNumber;
      } else {
        setNumber = totalNumber;
      }
      if (pagination && pagination[0]) {
        pagination[0].getElementsByClassName('current-slide')[0].innerHTML = '01';
        pagination[0].getElementsByClassName('total-slides')[0].innerHTML = setNumber;
      }

    }

  }

  public slideToPrev() {
    const currentSlide = this.swiper.directiveRef.swiper().el.parentElement.parentElement.getElementsByClassName('current-slide')[0];
    if (this.swiper.directiveRef.swiper().activeIndex === 0) {
      const newIndex = this.swiper.directiveRef.swiper().slides.length - 1;
      this.swiper.directiveRef.swiper().slideTo(newIndex);
    } else {
      this.swiper.directiveRef.swiper().slidePrev();
    }
    const index = this.swiper.directiveRef.swiper().activeIndex + 1;
    if (index < 10) {
      currentSlide.innerHTML = '0' + index.toString();
    } else {
      currentSlide.innerHTML = index.toString();
    }
  }

  public slideToNext() {
    const currentSlide = this.swiper.directiveRef.swiper().el.parentElement.parentElement.getElementsByClassName('current-slide')[0];
    if (this.swiper.directiveRef.swiper().activeIndex === this.swiper.directiveRef.swiper().slides.length - 1) {
      this.swiper.directiveRef.swiper().slideTo(0);
    } else {
      this.swiper.directiveRef.swiper().slideNext();
    }
    const index = this.swiper.directiveRef.swiper().activeIndex + 1;
    if (index < 10) {
      currentSlide.innerHTML = '0' + index.toString();
    } else {
      currentSlide.innerHTML = index.toString();
    }
  }

  public updateIndex() {
    const currentIndex = this.swiper.directiveRef.swiper().activeIndex + 1;
    const currentSlide = this.swiper.directiveRef.swiper().el.parentElement.parentElement.getElementsByClassName('current-slide')[0];

    if (currentIndex < 10) {
      currentSlide.innerHTML = '0' + currentIndex.toString();
    } else {
      currentSlide.innerHTML = currentIndex.toString();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    setTimeout(() => {this.swiper.directiveRef.update(); }, 500);
  }
}
